import dataBloedErnstigDOAC from "../../../../src/data/ernstige-bloedingen-onder-doac-dabigatran.json";
import BasicSchematic from "../../../../src/components/chart/interaction/basic-schematic/Chart.js";
import * as React from 'react';
export default {
  dataBloedErnstigDOAC,
  BasicSchematic,
  React
};